<template>
  <v-text-field
    v-if="field.canRead"
    v-model="value[field.fieldName]"
    :maxlength="field.info.maxlength ? field.info.maxlength : 100000"
    :counter="field.info.maxlength"
    :label="labelText"
    :disabled="!field.canEdit"
    hide-details

    :rounded="cs.inputRounded"
    :dense="cs.inputDense"
    :outlined="cs.inputOutlined"
    :filled="cs.inputFilled"
    :background-color="fieldBackgroundColor(value[field.fieldName], field)"

  >
    <v-select
      v-if="field.info.selectUnit"
      v-model="value[field.fieldName + 'unit']"
      :items="unitSelectOptions()"
      slot="append-outer"
      style="top: -20px; width: 50px"
      hide-details
    ></v-select>
  </v-text-field>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormNumber',

  props: {
    ...formElementProps
  },

  computed: {
    ...sharedComputed
  },

  methods: {
    ...sharedMethods
  },

  created () {
    if (this.field.info &&
      this.field.info.selectUnit &&
      this.field.info.defaultUnit
    ) {
      if (!this.value[this.field.fieldName + 'unit']) {
        this.value[this.field.fieldName + 'unit'] = this.field.info.defaultUnit
      }
    }
  }
}
</script>
